import * as React from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

interface ErrorDialogProps {
  handleErrorDialogClose: (e: any) => void
  isErrorDialogOpen: boolean
  errorTitle?: string
  errorMessage?: string
}

interface ErrorDialogState {
  isErrorDialogOpen: boolean
}

export default class ErrorDialog extends React.Component<ErrorDialogProps, ErrorDialogState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isErrorDialogOpen: this.props.isErrorDialogOpen
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props !== nextProps) {
      this.setState({
        isErrorDialogOpen: nextProps.isErrorDialogOpen
      })
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.isErrorDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="job-cancel-dialog"
        classes={{ paper: 'job-cancel-dialog-paper' }}
      >
        <DialogTitle id="alert-dialog-title">
          {
            this.props.errorTitle
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              this.props.errorMessage
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleErrorDialogClose} color="primary" name={this.props.errorTitle}>
            Ok
          </Button>
        </DialogActions>
      </Dialog >
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorDialog.tsx